/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GroupRoleUpdateData model module.
 * @module model/GroupRoleUpdateData
 * @version 1.0
 */
class GroupRoleUpdateData {
    /**
     * Constructs a new <code>GroupRoleUpdateData</code>.
     * @alias module:model/GroupRoleUpdateData
     */
    constructor() { 
        
        GroupRoleUpdateData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>GroupRoleUpdateData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GroupRoleUpdateData} obj Optional instance to populate.
     * @return {module:model/GroupRoleUpdateData} The populated <code>GroupRoleUpdateData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GroupRoleUpdateData();

            if (data.hasOwnProperty('groupNo')) {
                obj['groupNo'] = ApiClient.convertToType(data['groupNo'], 'Number');
            }
            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
            if (data.hasOwnProperty('readonly')) {
                obj['readonly'] = ApiClient.convertToType(data['readonly'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GroupRoleUpdateData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GroupRoleUpdateData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} groupNo
 */
GroupRoleUpdateData.prototype['groupNo'] = undefined;

/**
 * @member {Number} gnbNo
 */
GroupRoleUpdateData.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
GroupRoleUpdateData.prototype['lnbNo'] = undefined;

/**
 * @member {Number} subNo
 */
GroupRoleUpdateData.prototype['subNo'] = undefined;

/**
 * @member {Boolean} readonly
 */
GroupRoleUpdateData.prototype['readonly'] = undefined;






export default GroupRoleUpdateData;

